export default __webpack_public_path__ + "static/media/icon_phone_yellow.2fed30a4.svg";